import { render } from "./MatchSlider.vue?vue&type=template&id=34b50ec1&scoped=true"
import script from "./MatchSlider.vue?vue&type=script&lang=js"
export * from "./MatchSlider.vue?vue&type=script&lang=js"

import "./MatchSlider.vue?vue&type=style&index=0&id=34b50ec1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34b50ec1"]])

export default __exports__